/**
 * The HTML chip layer over the 2D assembly: the six measurements of the
 * selected room, the four gaps editable inline (moving the room), the two
 * extents read-only. Same chips, same geometry as the room editor's overlay.
 */
import { applyAssemblyChipEdit, isAssemblyGapKey, placedAssemblyBars, useFloorPlanAssemblerState } from '@kaiizen/kai-floor-plan-editor-core';
import { MeasureChips } from '../DimsOverlay';

export function AssemblyDimsOverlay({ stageW, stageH }: { stageW: number; stageH: number }): React.JSX.Element {
  const { st, mutate } = useFloorPlanAssemblerState();
  return (
    <MeasureChips
      placed={placedAssemblyBars(st, stageW, stageH)}
      editingKey={st.editingKey}
      readOnly={st.readOnly}
      isEditable={isAssemblyGapKey}
      onBeginEdit={key =>
        mutate(s => {
          s.editingKey = key;
        })}
      onCommit={(key, value) =>
        mutate(s => {
          s.editingKey = null;
          if (value != null) applyAssemblyChipEdit(s, key, value);
        })}
      onCancel={() =>
        mutate(s => {
          s.editingKey = null;
        })}
    />
  );
}
